// extracted by LIB_CSS_EXTRACT_LOADER
import "./skeleton_module.css"
export default {"skeleton":"skeleton-RLGgq2","pulse":"pulse-oKE0mf"};